const accountAggregator = 'https://staging.api.edgrofin.com/account-aggregator/private';

const baseUrls = {
    accountAggregator
};

export default baseUrls;
